// extracted by mini-css-extract-plugin
export default {"detailText":"Listview__detailText____1xGg","List":"Listview__List___daaEz"};